import { render, staticRenderFns } from "./UnassignedChangeTableList.vue?vue&type=template&id=84bd1012&scoped=true"
import script from "./UnassignedChangeTableList.vue?vue&type=script&lang=js"
export * from "./UnassignedChangeTableList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84bd1012",
  null
  
)

export default component.exports